import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createGetAction,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { StatusHistoryItem } from '../models/EmployeeDetails';

const actionConfig = {
  resourcePath: '/status-histories',
};

type StatusHistoryStoreState = RestStoreState<StatusHistoryItem>;
const genericActions = createRestActions<StatusHistoryItem>(actionConfig);
const statusHistoryActions = {
  ...genericActions,
  loadByEmployee: (employeeId: number | string) => async ({ dispatch }: StoreActionApi<StatusHistoryStoreState>) => {
    const getAction = createGetAction<StatusHistoryItem>({ resourcePath: `${actionConfig.resourcePath}?userId=${employeeId}` });
    await dispatch(getAction());
  },
  clearStatusHistory: () => ({ setState }: StoreActionApi<RestStoreState<StatusHistoryItem>>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const StatusHistoryStore = createRestStore<StatusHistoryItem>({
  actions: statusHistoryActions,
  actionConfig,
  containerDisplayName: 'status-history-container',
  onInitAction: null,
});

export const useStatusHistoryData = createDataHook(StatusHistoryStore);
export const useStatusHistoryIsLoading = createLoadingHook(StatusHistoryStore);
export const useStatusHistoryActions = createActionsHook(StatusHistoryStore);
export const didStatusHistoryMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
